var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeightManagement({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#C0D5C4;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#F8EEE1;}\n\t.st2{fill:#EFC05D;}\n\t.st3{fill:none;stroke:#2A384F;stroke-width:4.2396;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M105,185.7c42.7,0,77.3-34.3,77.3-76.6c0-42.3-34.6-76.6-77.3-76.6s-77.3,34.3-77.3,76.6 C27.7,151.4,62.3,185.7,105,185.7"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M138.1,156.3H71.7c-6.7,0-12.1-5.4-12.1-12.1V74c0-6.7,5.4-12.1,12.1-12.1h66.5c6.7,0,12.1,5.4,12.1,12.1v70.2 C150.3,150.9,144.8,156.3,138.1,156.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M87.9,98.1l-15.1-7.7c6.3-12.4,18.8-20.1,32.7-20.1l0,0c13.9,0,26.4,7.7,32.7,20.1l-15.1,7.7 c-3.4-6.8-10-10.8-17.6-10.8C97.9,87.3,91.4,91.4,87.9,98.1z"
  })), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 105.5,
    y1: 82.1,
    x2: 105.5,
    y2: 99.9
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeightManagement);
export default __webpack_public_path__ + "static/media/Weight_Management.95da26e075d45345571bb7f32a329ed5.svg";
export { ForwardRef as ReactComponent };